import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { IconeAvancar } from '../Icones.js';

export interface Migalha {
  rotulo: string;
  para?: string;
}

/** Trilha de navegacao: mostra onde se esta e leva de volta a qualquer nivel. */
export function Trilha({ itens }: { itens: readonly Migalha[] }) {
  return (
    <nav aria-label="Trilha" className="min-w-0">
      <ol className="flex min-w-0 flex-wrap items-center gap-1 text-[13px] text-apagado">
        {itens.map((m, i) => (
          <li key={`${m.rotulo}-${i}`} className="flex min-w-0 items-center gap-1">
            {i > 0 && <IconeAvancar width={14} height={14} className="shrink-0 opacity-60" />}
            {m.para ? (
              // O truncate fica no span: no link ele cortaria a area de toque ampliada.
              <Link to={m.para} className="alvo-toque min-w-0 hover:text-destaque-texto hover:underline">
                <span className="block truncate">{m.rotulo}</span>
              </Link>
            ) : (
              <span aria-current="page" className="truncate text-texto">
                {m.rotulo}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

/**
 * Cabecalho igual em todas as paginas: trilha, sobretitulo, titulo em serifa,
 * metadados e acoes. `selo` e um chip de contexto a direita (ex.: "Dados de
 * 03/10/2026"), antes das acoes.
 */
export function CabecalhoPagina({
  trilha,
  sobretitulo,
  titulo,
  meta,
  acoes,
  etiquetas,
  selo,
}: {
  trilha?: readonly Migalha[];
  sobretitulo?: ReactNode;
  titulo: ReactNode;
  meta?: ReactNode;
  acoes?: ReactNode;
  etiquetas?: ReactNode;
  selo?: ReactNode;
}) {
  return (
    <header className="space-y-3 border-b border-borda pb-5">
      {trilha && <Trilha itens={trilha} />}
      <div className="flex flex-wrap items-end justify-between gap-x-6 gap-y-3">
        <div className="min-w-0 space-y-1">
          {sobretitulo && <p className="rotulo-secao">{sobretitulo}</p>}
          <h1 className="font-serif text-[28px] leading-tight font-semibold tracking-tight text-marca sm:text-[34px]">
            {titulo}
          </h1>
          {(meta || etiquetas) && (
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 text-sm text-apagado">
              {etiquetas}
              {meta}
            </div>
          )}
        </div>
        {(selo || acoes) && (
          <div className="flex flex-wrap items-center gap-2">
            {selo && (
              <span className="inline-flex min-h-9 items-center gap-2 rounded-(--radius-chip) border border-borda bg-superficie px-3.5 text-[13px] whitespace-nowrap text-apagado shadow-cartao max-sm:hidden">
                {selo}
              </span>
            )}
            {acoes}
          </div>
        )}
      </div>
    </header>
  );
}
